import axios from "axios";


const AUTH_TOKEN = JSON.parse(localStorage.getItem("token"));


const auth = axios.create({

  // baseURL: "https://qa.adminserver.voucher.topupx.io", //QAs
  baseURL:"https://adminserver.voucher.topupx.io/",
  // baseURL: "http://localhost:3100",
  
  headers: {
    "Content-Typ": "application/json",
    "Authorization": AUTH_TOKEN,
  },
});

export default auth;
